import { render, staticRenderFns } from "./Greeting-Guide.vue?vue&type=template&id=512702a4&scoped=true"
import script from "./Greeting-Guide.vue?vue&type=script&lang=js"
export * from "./Greeting-Guide.vue?vue&type=script&lang=js"
import style0 from "./Greeting-Guide.vue?vue&type=style&index=0&id=512702a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512702a4",
  null
  
)

export default component.exports